module.exports = __webpack_public_path__ + "img/logo-ez.0838ae53.svg";